module.exports = __webpack_public_path__ + "static/edit_content_737x507-807a451cca76a250f1a76151631f865a.webp";